export default function sadminHeader() {
    let headers = {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
      "Authorization": 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFkbWluQGdtYWlsLmNvbSIsInBob25lbm8iOiI4NDMxNzMxOTU5IiwiaWF0IjoxNjg4MzYyMzEzfQ.6ovS9EkzlpRbzy00kHr9UCQ2irc5hl632xOHbcxC1mIII' 
    }
    return headers; // for Spring Boot back-end    
}